import { requestGet } from '@/common/request';

interface reqParams {
  groupId: number; // 分组id
}

interface ResultData {
  data: Array<{
    messageType: number; //消息类型id
    num: number; //消息数量
  }>;
}

/**
 * 消息中心-所有消息类型上未读消息数量
 * 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1121439607
 */
export default function genericMarketTypeNum(query: reqParams): Promise<RequestResult<ResultData>> {
  return requestGet('/generic/platMktMsgBk/message/marketTypeNum', query);
}
